var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "flex center-xs space-top-1 space-bottom-2" }),
      _vm._v(" "),
      _c("ButtonSection", {
        attrs: {
          inputValid: _vm.inputValid,
          order: _vm.order,
          buttonText: _vm.step.buttonText,
        },
        on: {
          progress: function ($event) {
            return _vm.$emit("progress")
          },
          back: function ($event) {
            return _vm.$emit("back")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }